import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProgramList } from "../redux/actions/Actions";
import { assets } from "../../assets/assets";
import { logout } from "../redux/auth/authActions";
import RequestCallback from "../RequestCallback";

/* ── Navbar layout styles ─────────────────────────────────── */
const navbarWrap = {
  display:         "flex",
  flexDirection:   "row",
  alignItems:      "center",
  justifyContent:  "space-between",
  height:          "64px",
  padding:         "0 32px",
  background:      "#FFFFFF",
  borderBottom:    "1px solid #E2E8F0",
  boxShadow:       "0 1px 8px rgba(37,99,235,0.07)",
  position:        "sticky",
  top:             0,
  zIndex:          1000,
};

const navbarLogo  = { display: "flex", alignItems: "center", textDecoration: "none", flexShrink: 0 };
const navbarLinks = { display: "flex", alignItems: "center", gap: "4px", flex: 1, justifyContent: "center" };
const navbarActions = { display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 };

/* ── Styles (defined first to avoid TDZ errors) ───────────── */
const linkStyle = {
  fontSize:       "14px",
  fontWeight:     500,
  padding:        "6px 10px",
  color:          "var(--clr-navbar-link, #1E293B)",
  textDecoration: "none",
};

const activeLinkStyle = {
  fontSize:       "14px",
  fontWeight:     600,
  padding:        "6px 10px",
  color:          "#2563EB",
  textDecoration: "none",
  borderBottom:   "2px solid #2563EB",
};

const loginBtnStyle = {
  display:        "inline-flex",
  alignItems:     "center",
  justifyContent: "center",
  padding:        "7px 18px",
  fontSize:       "14px",
  fontWeight:     600,
  color:          "#1E293B",
  background:     "transparent",
  border:         "1.5px solid #1E293B",
  borderRadius:   "8px",
  cursor:         "pointer",
  textDecoration: "none",
  transition:     "background 0.2s ease, color 0.2s ease",
  whiteSpace:     "nowrap",
};

const callbackBtnStyle = {
  display:        "inline-flex",
  alignItems:     "center",
  justifyContent: "center",
  padding:        "7px 18px",
  fontSize:       "14px",
  fontWeight:     600,
  color:          "#FFFFFF",
  background:     "#2563EB",
  border:         "none",
  borderRadius:   "8px",
  cursor:         "pointer",
  textDecoration: "none",
  transition:     "background 0.2s ease",
  whiteSpace:     "nowrap",
};

const navBtnStyle = {
  display:        "inline-flex",
  alignItems:     "center",
  gap:            "5px",
  background:     "none",
  border:         "none",
  cursor:         "pointer",
  fontWeight:     600,
  fontSize:       "14px",
  color:          "var(--clr-navbar-link, #1E293B)",
  padding:        "6px 10px",
  borderRadius:   "8px",
  transition:     "color 0.2s ease",
};

const megaStyle = {
  position:       "absolute",
  top:            "calc(100% + 12px)",
  left:           "50%",
  transform:      "translateX(-50%)",
  width:          "640px",
  background:     "#FFFFFF",
  border:         "1px solid #E2E8F0",
  borderRadius:   "16px",
  boxShadow:      "0 4px 6px rgba(0,0,0,0.04), 0 24px 56px rgba(15,23,42,0.14)",
  zIndex:         9999,
  overflow:       "hidden",
  animation:      "fadeSlideDown 0.18s ease",
};

const sectionHeader = {
  padding:        "14px 20px 10px",
  fontSize:       "11px",
  fontWeight:     700,
  letterSpacing:  "0.1em",
  color:          "#94A3B8",
  textTransform:  "uppercase",
  borderBottom:   "1px solid #F1F5F9",
};

const gridStyle = {
  display:              "grid",
  gridTemplateColumns:  "1fr 1fr",
  gap:                  "8px",
  padding:              "12px",
};

const gridItem = {
  display:        "flex",
  alignItems:     "center",
  gap:            "14px",
  padding:        "14px 16px",
  borderRadius:   "10px",
  border:         "1px solid #E2E8F0",
  background:     "#FFFFFF",
  textDecoration: "none",
  color:          "#1E293B",
  fontSize:       "14px",
  fontWeight:     500,
  lineHeight:     1.4,
  transition:     "background 0.15s ease, border-color 0.15s ease",
  cursor:         "pointer",
};

const iconBox = {
  flexShrink:     0,
  width:          "36px",
  height:         "36px",
  borderRadius:   "8px",
  background:     "#EFF6FF",
  color:          "#2563EB",
  display:        "flex",
  alignItems:     "center",
  justifyContent: "center",
};

const itemLabel = {
  fontWeight:     500,
  color:          "#1E293B",
  lineHeight:     1.4,
};

const megaFooter = {
  borderTop:      "1px solid #F1F5F9",
  padding:        "12px 20px",
  display:        "flex",
  justifyContent: "flex-end",
};

const viewAllLink = {
  display:        "inline-flex",
  alignItems:     "center",
  gap:            "6px",
  fontSize:       "13px",
  fontWeight:     600,
  color:          "#2563EB",
  textDecoration: "none",
  transition:     "color 0.15s ease",
};

/* ── Static program list shown in the mega menu ── */
const STATIC_PROGRAMS = [
  { label: 'Coding Bootcamp',              icon: <IconCode />,     path: '/programDetail/1' },
  { label: 'Developer Full Time Program',  icon: <IconIndustry />, path: '/programDetail/2' },
  { label: 'Internship',                   icon: <IconCert />,     path: '/programDetail/3' },
  { label: 'ESPRP',                        icon: <IconBridge />,   path: '/programDetail/4' },
]

/* ── SVG Icons ────────────────────────────────────────────── */
function IconCode() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
    </svg>
  );
}
function IconCert() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
    </svg>
  );
}
function IconBridge() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 17h18M3 17V7a2 2 0 012-2h3M21 17V7a2 2 0 00-2-2h-3M8 5v6M16 5v6M8 11a4 4 0 008 0"/>
    </svg>
  );
}
function IconIndustry() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/>
    </svg>
  );
}
function IconChevron({ open }) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
      style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s ease" }}>
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  );
}
function IconArrow() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
  );
}

/* ── Onboarding Dropdown ──────────────────────────────────── */
const OnboardingDropdown = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const timer = useRef(null);

  const onEnter = () => { clearTimeout(timer.current); setOpen(true); };
  const onLeave = () => { timer.current = setTimeout(() => setOpen(false), 120); };

  return (
    <div ref={ref} style={{ position: "relative" }} onMouseEnter={onEnter} onMouseLeave={onLeave}>
      <button style={navBtnStyle}
        onMouseEnter={e => e.currentTarget.style.color = "#2563EB"}
        onMouseLeave={e => e.currentTarget.style.color = "#1E293B"}
      >
        Partnership <IconChevron open={open} />
      </button>
      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 8px)", left: "50%", transform: "translateX(-50%)", background: "#fff", border: "1px solid #E2E8F0", borderRadius: "12px", boxShadow: "0 8px 32px rgba(15,23,42,0.12)", minWidth: "180px", zIndex: 9999, overflow: "hidden" }}>
        </div>
      )}
    </div>
  );
};

const obItemStyle = {
  display: "block", padding: "11px 20px", fontSize: "14px", fontWeight: 500,
  color: "#1E293B", textDecoration: "none", background: "#fff", transition: "background 0.15s",
};

/* ── Mega Menu ────────────────────────────────────────────── */
const ProgramsMegaMenu = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const closeTimer = useRef(null);

  const handleMouseEnter = () => { clearTimeout(closeTimer.current); setOpen(true); };
  const handleMouseLeave = () => { closeTimer.current = setTimeout(() => setOpen(false), 120); };

  return (
    <div ref={ref} style={{ position: "relative" }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <button
        style={navBtnStyle}
        onMouseEnter={e => e.currentTarget.style.color = "#2563EB"}
        onMouseLeave={e => e.currentTarget.style.color = "var(--clr-navbar-link, #1E293B)"}
      >
        Programs <IconChevron open={open} />
      </button>

      {open && (
        <div style={megaStyle}>
          <div style={sectionHeader}>ONLINE PROGRAMS</div>
          <div style={gridStyle}>
            {STATIC_PROGRAMS.map((p) => (
              <Link
                key={p.label}
                to={p.path}
                style={gridItem}
                onClick={() => setOpen(false)}
                onMouseEnter={e => { e.currentTarget.style.background = "#EFF6FF"; e.currentTarget.style.borderColor = "#BFDBFE"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "#FFFFFF"; e.currentTarget.style.borderColor = "#E2E8F0"; }}
              >
                <span style={iconBox}>{p.icon}</span>
                <span style={itemLabel}>{p.label}</span>
              </Link>
            ))}
          </div>

        </div>
      )}
    </div>
  );
};

/* ── Profile Dropdown ─────────────────────────────────────── */
const ProfileDropdown = ({ onLogout }) => {
  const [open, setOpen] = useState(false);
  const ref   = useRef(null);
  const user  = useSelector((s) => s.auth.user);
  const name  = user?.username || user?.name || 'Student';
  const email = user?.email || '';
  const initials = name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const menuItems = [
    {
      label: 'Dashboard', to: '/dashboard',
      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
    },
    {
      label: 'Browse Programs', to: '/programs',
      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>,
    },
    {
      label: 'Masterclass', to: '/masterclass',
      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>,
    },
    {
      label: 'Request Callback', to: '/request-callback',
      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.91a16 16 0 006.09 6.09l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>,
    },
  ];

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => setOpen(!open)} style={profileBtnStyle}>
        <div style={profileAvatarStyle}>{initials}</div>
        <div style={{ textAlign: 'left', lineHeight: 1.3 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#0F172A', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</div>
          <div style={{ fontSize: 11, color: '#94A3B8' }}>Student</div>
        </div>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2.5"
          style={{ flexShrink: 0, transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'none' }}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {open && (
        <div style={profileDropStyle}>
          {/* Header */}
          <div style={{ padding: '16px 18px 12px', borderBottom: '1px solid #F1F5F9' }}>
            <div style={profileAvatarLgStyle}>{initials}</div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#0F172A', marginTop: 10 }}>{name}</div>
            <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 2 }}>{email}</div>
          </div>

          {/* Menu */}
          <div style={{ padding: '8px 0' }}>
            {menuItems.map((item) => (
              <Link key={item.label} to={item.to} style={profileMenuItemStyle}
                onClick={() => setOpen(false)}
                onMouseEnter={e => e.currentTarget.style.background = '#EFF6FF'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <span style={{ display:'flex', alignItems:'center', flexShrink:0 }}>{item.icon}</span>
                {item.label}
              </Link>
            ))}
          </div>

          <div style={{ borderTop: '1px solid #F1F5F9', padding: '8px 0 6px' }}>
            <button style={{ ...profileMenuItemStyle, width: '100%', border: 'none', cursor: 'pointer', fontFamily: 'inherit', color: '#EF4444' }}
              onClick={() => { setOpen(false); onLogout(); }}
              onMouseEnter={e => e.currentTarget.style.background = '#FEF2F2'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const profileBtnStyle = {
  display: 'flex', alignItems: 'center', gap: 10,
  background: '#F8FAFC', border: '1.5px solid #E2E8F0', borderRadius: 10,
  padding: '7px 12px', cursor: 'pointer', transition: 'border-color 0.2s',
};
const profileAvatarStyle = {
  width: 32, height: 32, borderRadius: '50%',
  background: 'linear-gradient(135deg,#0D9488,#2563EB)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontSize: 13, fontWeight: 800, color: '#fff', flexShrink: 0,
};
const profileAvatarLgStyle = {
  width: 52, height: 52, borderRadius: '50%',
  background: 'linear-gradient(135deg,#0D9488,#2563EB)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontSize: 20, fontWeight: 800, color: '#fff', margin: '0 auto',
};
const profileDropStyle = {
  position: 'absolute', top: 'calc(100% + 10px)', right: 0,
  background: '#fff', border: '1px solid #E2E8F0', borderRadius: 14,
  boxShadow: '0 8px 32px rgba(15,23,42,0.12)', minWidth: 220,
  zIndex: 9999, overflow: 'hidden',
};
const profileMenuItemStyle = {
  display: 'flex', alignItems: 'center', gap: 10,
  padding: '10px 18px', fontSize: 13.5, fontWeight: 600,
  color: '#374151', textDecoration: 'none', background: 'transparent',
  transition: 'background 0.15s', width: '100%', boxSizing: 'border-box',
};

/* ── Navbar ───────────────────────────────────────────────── */
const Navbar = () => {
  const fetchPrograms   = useSelector((state) => state.fetchAllPrograms.programs);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch        = useDispatch();
  const navigate        = useNavigate();

  useEffect(() => { dispatch(fetchProgramList()); }, [dispatch]);

  const [showApply,   setShowApply]   = useState(false);
  const [applyProgram, setApplyProgram] = useState('');
  const [mobileOpen,  setMobileOpen]  = useState(false);
  const location = useLocation();

  // Close mobile menu on route change
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Allow other pages (e.g. Internship/ESPRP CTA buttons) to open the Apply Now modal
  useEffect(() => {
    const openApply = (e) => {
      setApplyProgram(e.detail?.program || '');
      setShowApply(true);
    };
    window.addEventListener('openApplyModal', openApply);
    return () => window.removeEventListener('openApplyModal', openApply);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname === '/') {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 350);
    }
  };

  const handleLogout = () => { dispatch(logout()); navigate("/"); };

  const mobileLink = {
    display: 'block', padding: '14px 24px', fontSize: 15, fontWeight: 600,
    color: '#1E293B', textDecoration: 'none', borderBottom: '1px solid #F1F5F9',
    background: 'none', border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer',
    fontFamily: "'Inter','Segoe UI',sans-serif",
  };

  return (
    <div id="header_section">
      <style>{`
        @media (max-width: 900px) {
          #navbar-links   { display: none !important; }
          #navbar-actions { display: none !important; }
          #navbar-hamburger { display: flex !important; }
        }
        @media (min-width: 901px) {
          #navbar-hamburger { display: none !important; }
          #navbar-mobile-drawer { display: none !important; }
        }
      `}</style>

      {/* ── Desktop navbar ── */}
      <nav id="navbar_top" style={navbarWrap}>

        <Link to="/" style={navbarLogo}>
          <img src={assets.logo_img} alt="UPL" style={{ height: "80px", width: "auto", display: "block" }} />
          {/* <span style={{ fontSize: "28px", fontWeight: 900, color: "#1A1F8C", letterSpacing: "0.04em" }}>UPL</span> */}
        </Link>

        {/* Desktop links */}
        <div id="navbar-links" style={navbarLinks}>
          {isAuthenticated ? (
            <Link to="/dashboard" style={{ ...linkStyle, fontWeight: 600 }}
              onMouseEnter={e => e.currentTarget.style.color = "#2563EB"}
              onMouseLeave={e => e.currentTarget.style.color = "#1E293B"}
            >Dashboard</Link>
          ) : (
            <Link to="/" style={activeLinkStyle}>Home</Link>
          )}
          <ProgramsMegaMenu />
          <button style={{ ...linkStyle, background: 'none', border: 'none', cursor: 'pointer' }} onClick={() => scrollToSection('how-it-works')} onMouseEnter={e => e.currentTarget.style.color="#2563EB"} onMouseLeave={e => e.currentTarget.style.color="#1E293B"}>How It Works</button>
          <Link to="/masterclass" style={linkStyle} onMouseEnter={e => e.currentTarget.style.color="#2563EB"} onMouseLeave={e => e.currentTarget.style.color="#1E293B"}>Live Projects</Link>
          <button style={{ ...linkStyle, background: 'none', border: 'none', cursor: 'pointer' }} onClick={() => scrollToSection('success-stories')} onMouseEnter={e => e.currentTarget.style.color="#2563EB"} onMouseLeave={e => e.currentTarget.style.color="#1E293B"}>Success Stories</button>
          <button style={{ ...linkStyle, background:'none', border:'none', cursor:'pointer' }} onClick={() => scrollToSection('home-employ')} onMouseEnter={e => e.currentTarget.style.color="#2563EB"} onMouseLeave={e => e.currentTarget.style.color="#1E293B"}>Institutions</button>
          <Link to="/about" style={linkStyle} onMouseEnter={e => e.currentTarget.style.color="#2563EB"} onMouseLeave={e => e.currentTarget.style.color="#1E293B"}>About Us</Link>
          {/* <Link to="/contact" style={linkStyle} onMouseEnter={e => e.currentTarget.style.color="#2563EB"} onMouseLeave={e => e.currentTarget.style.color="#1E293B"}>Contact Us</Link> */}
        </div>

        {/* Desktop actions */}
        <div id="navbar-actions" style={navbarActions}>
          {!isAuthenticated ? (
            <>
              <Link to="/login" style={loginBtnStyle}
                onMouseEnter={e => { e.currentTarget.style.background="#1E293B"; e.currentTarget.style.color="#fff"; }}
                onMouseLeave={e => { e.currentTarget.style.background="transparent"; e.currentTarget.style.color="#1E293B"; }}
              >Login</Link>
              <button style={{ ...callbackBtnStyle, border: 'none', cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.background="#1D4ED8"}
                onMouseLeave={e => e.currentTarget.style.background="#2563EB"}
                onClick={() => setShowApply(true)}>Apply Now</button>
            </>
          ) : (
            <ProfileDropdown onLogout={handleLogout} />
          )}
        </div>

        {/* Hamburger button — mobile only */}
        <button id="navbar-hamburger"
          onClick={() => setMobileOpen(o => !o)}
          style={{ display: 'none', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, background: 'none', border: '1.5px solid #E2E8F0', borderRadius: 8, cursor: 'pointer', flexShrink: 0 }}
          aria-label="Menu"
        >
          {mobileOpen
            ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E293B" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E293B" strokeWidth="2.5" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          }
        </button>
      </nav>

      {/* ── Mobile drawer ── */}
      <div id="navbar-mobile-drawer" style={{
        position: 'fixed', top: 64, left: 0, right: 0, bottom: 0,
        background: '#fff', zIndex: 999, overflowY: 'auto',
        borderTop: '1px solid #E2E8F0',
        transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 0.28s ease',
        boxShadow: '4px 0 24px rgba(0,0,0,0.1)',
      }}>
        <div style={{ padding: '8px 0 24px' }}>

          {isAuthenticated
            ? <Link to="/dashboard" style={mobileLink}>Dashboard</Link>
            : <Link to="/" style={mobileLink}>Home</Link>
          }

          {/* Programs submenu */}
          <div style={{ borderBottom: '1px solid #F1F5F9' }}>
            <div style={{ ...mobileLink, color: '#64748B', fontSize: 11, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', paddingBottom: 8, paddingTop: 16 }}>Programs</div>
            {[
              { label: 'Coding Bootcamp',            to: '/programDetail/1' },
              { label: 'Developer Full Time Program', to: '/programDetail/2' },
              { label: 'Internship',                  to: '/programDetail/3' },
              { label: 'ESPRP',                       to: '/programDetail/4' },
            ].map(p => (
              <Link key={p.to} to={p.to} style={{ ...mobileLink, paddingLeft: 36, fontSize: 14, color: '#374151', borderBottom: 'none', paddingTop: 10, paddingBottom: 10 }}>{p.label}</Link>
            ))}
          </div>

          <button style={mobileLink} onClick={() => { setMobileOpen(false); scrollToSection('how-it-works'); }}>How It Works</button>
          <Link to="/masterclass" style={mobileLink}>Live Projects</Link>
          <button style={mobileLink} onClick={() => { setMobileOpen(false); scrollToSection('success-stories'); }}>Success Stories</button>
          <button style={mobileLink} onClick={() => { setMobileOpen(false); scrollToSection('home-employ'); }}>Institutions</button>
          <Link to="/about" style={mobileLink}>About Us</Link>
          {/* <Link to="/contact" style={mobileLink}>Contact Us</Link> */}

          <div style={{ padding: '16px 24px 24px', display:'flex', flexDirection:'column', gap:10 }}>
            <Link to="/login" onClick={() => setMobileOpen(false)}
              style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:'13px', border:'1.5px solid #E2E8F0', borderRadius:10, fontSize:15, fontWeight:600, color:'#1E293B', textDecoration:'none', background:'#fff' }}>
              Login
            </Link>
            <button
              style={{ ...callbackBtnStyle, border: 'none', cursor: 'pointer', width: '100%', justifyContent: 'center', padding: '13px', fontSize: 15, borderRadius: 10 }}
              onClick={() => { setMobileOpen(false); setShowApply(true); }}>
              Apply Now
            </button>
          </div>

        </div>
      </div>

      {/* Overlay when mobile menu open */}
      {mobileOpen && (
        <div onClick={() => setMobileOpen(false)}
          style={{ position: 'fixed', inset: 0, top: 64, background: 'rgba(0,0,0,0.3)', zIndex: 998 }} />
      )}

      {showApply && (
        <RequestCallback isModal={true} onClose={() => { setShowApply(false); setApplyProgram(''); }} defaultProgram={applyProgram} />
      )}
    </div>
  );
};

export default Navbar;
